"use strict";

exports.__esModule = true;
exports.deepClone = deepClone;
exports.isObjectLike = isObjectLike;
exports.has = has;
exports.get = get;
exports.set = set;

function _createForOfIteratorHelperLoose(o) { var i = 0; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (o = _unsupportedIterableToArray(o))) return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } i = o[Symbol.iterator](); return i.next.bind(i); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * Deep clone of value.
 * @param value
 */
function deepClone(value) {
  return JSON.parse(JSON.stringify(value));
}
/**
 * Checks if value is object-like. A value is object-like if it"s not null and has a typeof result of "object".
 * @param value
 */


function isObjectLike(value) {
  return value !== null && typeof value === "object";
}
/**
 * Checks if path is a direct property of object.
 * @param object
 * @param path
 */


function has(object, path) {
  var newPath = Array.isArray(path) ? path : path.split(".");
  var current = object;

  for (var _iterator = _createForOfIteratorHelperLoose(newPath), _step; !(_step = _iterator()).done;) {
    var key = _step.value;

    if (!isObjectLike(current)) {
      return false;
    }

    if (!(key in current)) {
      return false;
    }

    current = current[key];
  }

  return true;
}
/**
 * Get object value from path. Otherwise return defaultValue.
 * @param object
 * @param path
 * @param defaultValue
 */


function get(object, path, defaultValue) {
  var newPath = Array.isArray(path) ? path : path.split(".");
  var current = object;

  for (var _iterator2 = _createForOfIteratorHelperLoose(newPath), _step2; !(_step2 = _iterator2()).done;) {
    var key = _step2.value;

    if (!isObjectLike(current)) {
      return defaultValue;
    }

    if (!(key in current)) {
      return defaultValue;
    }

    current = current[key];
  }

  return current === undefined ? defaultValue : current;
}
/**
 * Update object value on path.
 * @param object
 * @param path
 * @param value
 */


function set(object, path, value) {
  var current = object;
  var newPath = Array.isArray(path) ? path : path.split(".");

  for (var i = 0; i < newPath.length; ++i) {
    if (i === newPath.length - 1) {
      current[newPath[i]] = value;
    } else {
      current = current[newPath[i]];
    }
  }
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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